<template>
  <div>
    <v-dialog
      v-model="addModalOk"
      width="600px"
      :active="addModalOk"
      :on-cancel="
        () => {
          ;(addModalOk = false),
            (dropVideoThumbnail = []),
            (dropFile = []),
            (dropFileFlash = []),
            clearInputs()
        }
      "
    >
      <div v-if="isUpload">
        <form @submit.prevent="uploadNow">
          <v-card>
            <v-toolbar dark color="darkblue" v-if="isUpload">
              <v-toolbar-title>
                {{
                  lessionUpload ? 'Add Lesson Guide' : 'Upload Session Content'
                }}</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              <v-text-field
                counter
                maxlength="50"
                v-if="!lessionUpload"
                :disabled="selectedSessionID ? true : false"
                label="Session name *"
                v-model.trim="sessionName"
                placeholder="Session Name"
                required
              >
              </v-text-field>
              <div class="field">
                <label class="label">
                  {{ inputTitle }}
                </label>
                <v-file-input
                  :label="lessionUpload ? 'Lesson Guide' : 'Sesion Video'"
                  v-model="dropFile"
                  @change="fileChanged"
                  chips
                  :multiple="false"
                  truncate-length="15"
                ></v-file-input>
                <br />
                <span class="has-text-danger"
                  >Allowed file's:
                  {{
                    lessionUpload
                      ? '.pdf, .pptx, .ppt,.doc, .docx, .docm'
                      : '.mov, .mpg, .avi, .mp4, .wmv,.m4v'
                  }}
                </span>
                <br />
                <v-file-input
                  v-if="!lessionUpload"
                  label="Video Thumbnail"
                  v-model="dropVideoThumbnail"
                  @change="thumbnailFileChanged"
                  chips
                  :multiple="false"
                  truncate-length="15"
                ></v-file-input>
                <br />
                <v-file-input
                  v-if="!lessionUpload"
                  label="Flashcards"
                  v-model="dropFileFlash"
                  @change="fileChangedFlash"
                  chips
                  :multiple="!lessionUpload"
                  truncate-length="15"
                >
                </v-file-input>
                <br />
                <span v-if="!lessionUpload" class="has-text-danger"
                  >Allowed file's: '.pdf, .doc, .pptx, .ppt, .docx, .docm,
                  .pps'</span
                >
                <span class="has-text-danger"
                  >File's that are not supported will be removed
                  automatically!</span
                >
                <div class="field" v-if="!lessionUpload">
                  <v-textarea
                    counter
                    name="description"
                    label="Session Description"
                    v-model.trim="ssnDesc"
                  ></v-textarea>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                @click="
                  () => {
                    ;(addModalOk = false),
                      (dropFile = []),
                      (dropVideoThumbnail = []),
                      (dropFileFlash = []),
                      uploadInputsClear()
                  }
                "
              >
                Close</v-btn
              >
              <v-btn color="primary" type="submit">Upload</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </div>
      <div v-else>
        <form @submit.prevent="addFolder">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Create Folder</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div class="field">
                <v-autocomplete
                  key="id"
                  label="Select Class Group"
                  :items="classes"
                  v-model="selectedClassID"
                  required
                  :disabled="!isMain"
                  item-text="name"
                  item-value="id"
                  :hide-details="true"
                >
                </v-autocomplete>
              </div>

              <div class="field" v-if="isMain">
                <label class="label"
                  >Select Academic Year
                  <span class="has-text-danger">*</span></label
                >
                <span class="select is-fullwidth">
                  <select
                    name="academicYear"
                    v-model="academicYearID"
                    required
                    label="Select"
                  >
                    <option
                      :value="year.id"
                      v-for="year in academicYears"
                      :key="year.id"
                    >
                      {{ year.academicYear }}
                    </option>
                  </select>
                </span>
              </div>
              <div
                class="field"
                v-if="listType === 'WEEK' || listType === 'DAY'"
              >
                <v-autocomplete
                  key="id"
                  :disabled="listType === 'DAY'"
                  label="Select Week"
                  :items="getWeekWiseValue"
                  v-model="selectedWeek"
                  required
                  item-text="name"
                  item-value="name"
                  :hide-details="true"
                >
                </v-autocomplete>
              </div>
              <div class="field" v-if="listType === 'DAY'">
                <v-autocomplete
                  key="id"
                  label="Select Day"
                  :items="getDayWiseValue"
                  v-model="selectedDay"
                  required
                  item-text="name"
                  item-value="name"
                  :hide-details="true"
                >
                </v-autocomplete>
              </div>
              <div class="field">
                <v-textarea
                  counter
                  v-if="!isMain"
                  name="description"
                  label="Description"
                  v-model.trim="description"
                ></v-textarea>
              </div>
              <div class="field" v-if="!isMain">
                <v-radio-group
                  v-model="isActive"
                  mandatory
                  row
                  label="Is Active"
                >
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No" value="false"></v-radio>
                </v-radio-group>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                @click="
                  () => {
                    ;(addModalOk = false), clearInputs()
                  }
                "
                >Close</v-btn
              >
              <v-btn color="primary" type="submit">Create</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </div>
    </v-dialog>
    <v-dialog
      v-model="editModalOk"
      width="600px"
      :active="editModalOk"
      :on-cancel="
        () => {
          ;(editModalOk = false), closeEdit()
        }
      "
    >
      <form @submit.prevent="editFolderData">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Edit Folder</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div class="field">
              <v-text-field
                readonly
                v-model="folderData.folderName.name"
                counter="25"
                label="New Folder Name"
              ></v-text-field>
            </div>
            <div class="field">
              <v-textarea
                name="description"
                label="Description"
                v-model.trim="folderData.description"
              ></v-textarea>
            </div>
            <div class="field" v-if="!isMain">
              <v-radio-group
                v-model="folderData.isActive"
                mandatory
                row
                label="Is Active"
              >
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              @click="
                () => {
                  ;(addModalOk = false), closeEdit()
                }
              "
              >Close
            </v-btn>
            <v-btn color="primary" type="submit">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>

    <v-container fluid>
      <!-- <material-card icon="mdi-checkbox-marked-outline" title="Recorded Video Section"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div
                  class="font-weight-regular headline text-decoration-underline text-capitalize"
                >
                  <span>Recorded Video Section</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </v-card-actions>

        <card-component>
          <p>
            <i>
              {{ selectedClassObj[0] && !isMain ? selectedClassObj[0].name : ''
              }}{{ weekNo ? ' >> ' : '' }}{{ weekNo ? selectedWeek : ''
              }}{{ dayNo ? ' >> ' : '' }}{{ dayNo ? selectedDay : '' }}
            </i>
          </p>
          <div v-if="!isInputfiledEnabled">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <p class="subtitle">Folder</p>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <v-btn
                    color="grey"
                    @click="
                      () => {
                        listView = !listView
                      }
                    "
                    :title="listView ? 'Folder View' : 'List View'"
                    elevation="1"
                  >
                    <v-icon>{{
                      listView ? 'mdi-view-grid' : 'mdi-view-list'
                    }}</v-icon>
                  </v-btn>
                </div>
                <div class="level-item" v-if="isWrite">
                  <div v-if="!isInputfiledEnabled">
                    <v-btn
                      title="Add New Folder"
                      color="accent"
                      @click="modalOpen"
                      elevation="1"
                      right
                      top
                    >
                      <v-icon left>mdi-plus</v-icon>Add new
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div v-if="!listView">
              <v-row v-if="foldersArr.length > 0">
                <v-col
                  v-for="folder in foldersArr"
                  :key="folder.id"
                  cols="12"
                  lg="2"
                >
                  <v-card
                    v-if="foldersArr.length > 0"
                    :color="folder.isActive ? 'orange' : 'grey'"
                    class="rounded-lg mx-auto pl-1"
                    elevation="2"
                    @click="
                      getFolder(
                        folder.id,
                        null,
                        folder.id,
                        folder.classID,
                        folder
                      )
                    "
                  >
                    <div
                      class="d-flex flex-no-wrap justify-space-between"
                      style="background-color: white; height: 100px"
                    >
                      <div>
                        <v-card-title class="text-h5 black--text">
                          <span>
                            <v-icon color="gray" x-large
                              >mdi-google-classroom</v-icon
                            >
                          </span>
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                black
                                icon
                                v-bind="attrs"
                                v-on="on"
                                absolute
                                top
                                right
                              >
                                <v-icon color="gray">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item link>
                                <v-list-item-title
                                  aria-role="listitem"
                                  @click="editFolder(folder.id)"
                                  >Edit</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item link>
                                <v-list-item-title
                                  aria-role="listitem"
                                  @click="activeDeactiveFolder(folder.id)"
                                >
                                  {{
                                    folder.isActive ? 'Deactivate' : 'Activate'
                                  }}
                                </v-list-item-title>
                              </v-list-item>
                              <!-- <v-list-item link>
                                <v-list-item-title aria-role="listitem"
                                  @click="deleteFolder(folder.id)">Delete</v-list-item-title>
                              </v-list-item> -->
                            </v-list>
                          </v-menu>
                        </v-card-title>
                        <v-card-subtitle class="shortFoldername"
                          >{{ folder.folderName.name }}
                        </v-card-subtitle>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <p v-else>No folders here!!</p>
            </div>
            <v-data-table
              v-else
              :headers="headers"
              :items="foldersArr"
              :search="search"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.folderName.name="{ item }">
                <span
                  class="islink"
                  @click="getFolder(item.id, null, item.id, item.classID, item)"
                  >{{ item.folderName.name.toUpperCase() }}</span
                >
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  @click="editFolder(item.id)"
                  color="primary"
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  outlined
                  x-small
                  >Edit</v-btn
                >
                <v-btn
                  :title="item.isActive ? 'Deactivate' : 'Activate'"
                  @click="activeDeactiveFolder(item.id)"
                  class="px-2 ml-1 ma-1"
                  :color="item.isActive ? 'warning' : 'success'"
                  min-width="0"
                  outlined
                  x-small
                >
                  {{ item.isActive ? 'Deactivate' : 'Activate' }}</v-btn
                >
                <!--<v-btn title="Delete" class="px-2 ml-1 ma-1" color="error"
                  @click="deleteFolder(item.id)" min-width="0" outlined x-small>Delete</v-btn> -->
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center"
                  >No Folders Available
                </v-card-subtitle>
              </template>
            </v-data-table>
            <hr />
          </div>
          <div v-if="isInputfiledEnabled">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle">Files</p>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <v-btn
                  v-if="lessionGuide.length === 0"
                  title="Upload Lesson Guide"
                  @click="modalOpen('upload', 'lession')"
                  elevation="1"
                  top
                  color="accent"
                >
                  <v-icon left>mdi-plus</v-icon>Add LEsson Guide
                </v-btn>
              </div>
              <div class="level-item">
                <v-btn
                  title="Upload Session Content"
                  @click="modalOpen('upload', 'session')"
                  elevation="1"
                  top
                  color="accent"
                >
                  <v-icon left>mdi-plus</v-icon>Add Session Content
                </v-btn>
              </div>
            </div>
            <v-container fluid>
              <v-subheader class="text-h6">LESSON GUIDE </v-subheader>
              <v-card>
                <v-simple-table v-if="lessionGuide[0]">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>
                          <span
                            class="islink"
                            @click="fileOpen(lessionGuide[0].url)"
                          >
                            {{ lessionGuide[0].fileName }}</span
                          >
                        </td>
                        <td>
                          <div class="text-right">
                            <v-btn
                              :title="
                                lessionGuide[0].isActive
                                  ? 'Deactivate'
                                  : 'Activate'
                              "
                              @click="activeInactiveFile(lessionGuide[0].id)"
                              class="px-2 ml-1 ma-1"
                              :color="
                                lessionGuide[0].isActive ? 'warning' : 'success'
                              "
                              min-width="0"
                              small
                            >
                              {{
                                lessionGuide[0].isActive
                                  ? 'Deactivate'
                                  : 'Activate'
                              }}</v-btn
                            >
                            <v-btn
                              title="Delete"
                              class="px-2 ml-1 ma-1"
                              color="error"
                              @click="deleteFile(lessionGuide[0].id)"
                              min-width="0"
                              small
                              >Delete
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <template v-else>
                  <v-card-subtitle class="d-flex"
                    >No Files Available</v-card-subtitle
                  >
                </template>
                <hr />
              </v-card>

              <v-subheader class="text-h6">SESSION FILES </v-subheader>
              <div v-if="filesData.length">
                <v-card v-for="session in filesData" :key="session.id">
                  <v-card-title>
                    {{ session.sessionName }}
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="
                        updateModal(
                          session.sessionId,
                          session.sessionName,
                          'session',
                          session.description
                        )
                      "
                    >
                      Add new Files</v-btn
                    >
                  </v-card-title>
                  <v-card-text>{{ session.description }}</v-card-text>
                  <v-data-table
                    :headers="ssnHeaders"
                    :items="session.files"
                    hide-default-footer
                    hide-default-header
                  >
                    <template v-slot:item.fileName="{ item }">
                      <span
                        class="islink isBlueLink"
                        @click="fileOpen(item.url)"
                        >{{ item.fileName }}</span
                      >
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="text-right">
                        <v-btn
                          v-if="item.documentExtensionType === 'VIDEO'"
                          title="Edit"
                          class="px-2 ml-1 ma-1"
                          color="primary"
                          @click="editModal(item, session.sessionName)"
                          min-width="0"
                          small
                          >Edit
                        </v-btn>
                        <v-btn
                          :title="item.isActive ? 'Deactivate' : 'Activate'"
                          @click="activeInactiveFile(item.id)"
                          class="px-2 ml-1 ma-1"
                          :color="item.isActive ? 'warning' : 'success'"
                          min-width="0"
                          small
                        >
                          {{ item.isActive ? 'Deactivate' : 'Activate' }}</v-btn
                        >
                        <v-btn
                          title="Delete"
                          class="px-2 ml-1 ma-1"
                          color="error"
                          @click="deleteFile(item.id)"
                          min-width="0"
                          small
                          >Delete
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <v-card-subtitle class="d-flex"
                        >No Files Available</v-card-subtitle
                      >
                    </template>
                  </v-data-table>
                  <hr />
                </v-card>
              </div>
              <v-card v-else>
                <template>
                  <v-card-subtitle class="d-flex"
                    >No Sessions Available</v-card-subtitle
                  >
                </template>
              </v-card>
            </v-container>
          </div>
          <hr v-if="!isMain" />
        </card-component>
      </v-card>
      <!-- </material-card> -->
    </v-container>
    <b-modal
      width="600px"
      :active="editDataOk"
      :on-cancel="
        () => {
          ;(editDataOk = false), (dropVideoThumbnail = []), clearInputs()
        }
      "
    >
      <header class="modal-card-head">
        <p class="modal-card-title" v-if="editDataOk">
          <strong>Edit Session Content </strong>
        </p>
      </header>
      <div class="card">
        <div class="card-content" v-if="editDataOk">
          <form @submit.prevent="updateVideo">
            <section class="modal-card-body">
              <v-text-field
                counter
                maxlength="50"
                :disabled="true"
                label="Session name *"
                v-model.trim="sessionName"
                placeholder="Session Name"
              >
              </v-text-field>
              <v-text-field
                counter
                maxlength="50"
                :disabled="true"
                label="Video name"
                v-model.trim="fileName"
                placeholder="Video Name"
              >
              </v-text-field>
              <div class="field">
                <label class="label">
                  {{ inputTitle }}
                </label>
                <v-row>
                  <v-file-input
                    label="Video Thumbnail (Allowed file's: '.jpg, .png, .jpeg)"
                    v-model="dropVideoThumbnail"
                    @change="thumbnailFileChanged"
                    chips
                    :multiple="false"
                    placeholder="Video Thumbnail"
                    truncate-length="15"
                  >
                  </v-file-input>
                  <span v-if="thumbnailurl" class="islink">
                    <button
                      class="button is-white is-rounded"
                      type="button"
                      is-active="!thumbnailurl"
                      @click="
                        () => {
                          fileOpen(thumbnailurl)
                        }
                      "
                    >
                      View Thumbnail
                    </button></span
                  >
                </v-row>
                <v-row>
                  <v-text-field
                    counter
                    maxlength="3"
                    label="Video duration (Minutes)"
                    v-model.trim="videoDurationMinutes"
                    placeholder="Video duration (Minutes)"
                    required
                  ></v-text-field
                  ><br />
                  <v-text-field
                    counter
                    maxlength="3"
                    label="Video duration (Seconds)"
                    v-model.trim="videoDurationSeconds"
                    placeholder="Video duration (Seconds)"
                    required
                  ></v-text-field>
                </v-row>

                <span class="has-text-danger"
                  >File's that are not supported will be removed
                  automatically!</span
                >
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button"
                type="button"
                @click="
                  () => {
                    ;(editDataOk = false),
                      (dropVideoThumbnail = []),
                      uploadInputsClear()
                  }
                "
              >
                Close
              </button>
              <button class="button is-primary" type="submit">Update</button>
            </footer>
          </form>
        </div>
      </div>
    </b-modal>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
// import MaterialCard from '@/components/template/MaterialCard'
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
import { mapGetters } from 'vuex'

// import orderTatsReportVue from '../../Reports/orderTatsReport.vue'

export default {
  name: 'RecordedVideos',
  components: {
    CardComponent
    // MaterialCard
  },
  props: ['folderId', 'classID', 'folder', 'weekNo', 'dayNo'],
  data () {
    return {
      valid: true,
      dialog: false,
      modules: {
        RenameFolder: this.checkModuleAccess('RenameFolder'),
        DeleteFolder: this.checkModuleAccess('DeleteFolder'),
        DeleteFile: this.checkModuleAccess('DeleteFile')
      },
      academicYears: [],
      getList: [],
      sessionName: '',
      position: '',
      filesData: [],
      selectedClassID: null,
      isLoading: true,
      classes: [],
      addModalOk: false,
      folderName: '',
      franchiseeID: '',
      academicYearID: '',
      foldersArr: [],
      isMain: true,
      parentFolderId: '',
      isUpload: false,
      editDataOk: false,
      fileName: '',
      videoDurationSeconds: '',
      duration: '',
      videoDurationMinutes: '',
      thumbnailurl: '',
      thumbnailName: '',
      selectedVideoID: '',
      dropFile: [],
      inputTitle: "Select file('s)",
      dropFileFlash: [],
      renameModal: false,
      newName: '',
      oldName: '',
      renameId: '',
      idForUpload: '',
      files: [],
      isInputfiledEnabled: false,
      lessonGuide: [],
      isWrite: false,
      allowedThumbnailFiles: ['jpg', 'png', 'jpeg'],
      allowedLessionFiles: ['pdf', 'pptx', 'ppt', 'docx', 'docm', 'pps'],
      allowedFlashFiles: ['pdf', 'doc', 'pptx', 'ppt', 'docx', 'docm', 'pps'],
      allowedSessionFiles: ['mov', 'mpg', 'avi', 'mp4', 'wmv', 'm4v'],
      isActive: true,
      description: '',
      JSONARRAY: [],
      lessionGuide: [],
      search: '',
      dropVideoThumbnail: [],
      tempDropVideoThumbnail: [],
      headers: [
        { text: 'Folder name', value: 'folderName.name' },
        { text: 'Classes', value: 'classes' },
        { text: 'Description', value: 'description', width: '200px' },
        { text: 'Actions', value: 'actions', width: '250px' }
      ],
      ssnHeaders: [
        { text: 'Folder name', value: 'fileName' },
        { text: 'Actions', value: 'actions' }
      ],
      listView: true,
      isWeek: false,
      isDay: false,
      listType: '',
      isInsideDay: false,
      selectedWeek: '',
      selectedDay: '',
      lessionUpload: '',
      selectedClassObj: '',
      selectedSessionID: '',
      editModalOk: false,
      selectedSessionName: '',
      // dayNameInput: '',
      folderData: {
        folderName: {
          name: ''
        },
        description: '',
        isActive: false
      },
      ssnDesc: ''
    }
  },
  async created () {
    await this.onFranchiseeChange()
    await this.getAcademicYears()

    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    this.selectedClassID = parseInt(this.classID)

    // await this.getFolder(this.folderId, 'fromWatch')

    await this.getFolder(
      this.folderId,
      'fromWatch',
      this.folderId,
      this.selectedClassID,
      this.folder
    )

    if (this.folder) {
      if (this.folder.nameType === 'WEEK') {
        this.selectedWeek = this.folder.folderName.name.toUpperCase()
      }
      if (this.folder.nameType === 'DAY') {
        this.selectedDay = this.folder.folderName.name.toUpperCase()
      }
    }
    if (this.weekNo) {
      this.selectedWeek = `WEEK ${this.weekNo}`
    }
    if (this.dayNo) {
      this.selectedDay = `DAY ${this.dayNo}`
    }
  },
  computed: {
    getWeekWiseValue () {
      let temp = []
      for (let i = 1; i <= 37; i++) {
        temp.push({ id: i, name: `WEEK ${i}` })
      }
      return temp
    },
    getDayWiseValue () {
      let temp = []
      for (let i = 1; i <= 5; i++) {
        temp.push({ id: i, name: `DAY ${i}` })
      }
      return temp
    },
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },

  mounted: async function () {
    if (this.weekNo) {
      this.listType = 'DAY'
    }
    this.selectedClassID = parseInt(this.classID)
    if (this.classID && !this.weekNo) {
      this.listType = 'WEEK'
    }
    if (this.classID && this.weekNo && this.dayNo) {
      this.listType = 'FILE'
    }
  },
  watch: {
    folderId (val) {
      this.filesData = []
      this.foldersArr = []

      if (this.folder) {
        if (this.folder.nameType === 'WEEK') {
          this.selectedWeek = this.folder.folderName.name.toUpperCase()
        }
        if (this.folder.nameType === 'DAY') {
          this.selectedDay = this.folder.folderName.name.toUpperCase()
        }
      }
      if (this.weekNo) {
        this.selectedWeek = `WEEK ${this.weekNo}`
      }
      if (this.dayNo) {
        this.selectedDay = `DAY ${this.dayNo}`
      }

      if (this.weekNo) {
        this.listType = 'DAY'
      }
      if (this.classID && !this.weekNo) {
        this.listType = 'WEEK'
      }
      if (this.classID && this.weekNo && this.dayNo) {
        this.listType = 'FILE'
      }
      this.getFolder(val, 'fromWatch', val, parseInt(this.classID), this.folder)
    },
    isMain () {
      if (this.isMain) {
        this.selectedClassID = ''
      }
    },
    listType () {
      if (this.listType === 'WEEK') {
        this.selectedWeek = ''
      }
      if (this.listType === 'DAY') {
        this.selectedDay = ''
      }
    },
    academicYear: async function (val) {
      this.files = []
      this.foldersArr = []
      this.academicYearID = val.id
      await this.getFolder(this.folderId, 'fromWatch')
    },
    franchisee: async function (val) {
      this.files = []
      this.foldersArr = []
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getClassList()
        this.inProgress = false
      }
    },
    fileChangedFlash: async function () {
      let r = this.dropFileFlash.filter((a, i) => {
        if (this.allowedFlashFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFlashFiles.includes(a.name.split('.').pop())
      })
      this.dropFileFlash = r
    },
    fileChanged: async function () {
      let allowedFiles = this.lessionUpload
        ? this.allowedLessionFiles
        : this.allowedSessionFiles
      let r = this.dropFile.filter((a, i) => {
        if (allowedFiles.includes(a.name.split('.').pop())) {
        }
        return allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
      if (!this.lessionUpload) {
        this.tempDropVideoThumbnail = []
        for (var i = 0; i < this.dropFile.length; i++) {
          var file = this.dropFile[i]
          var fileReader = new FileReader()
          fileReader.onload = () => {
            var blob = new Blob([fileReader.result], { type: file.type })
            var url = URL.createObjectURL(blob)
            var video = document.createElement('video')
            video.addEventListener('loadeddata', async () => {
              let duration1 = await snapImage()
              this.duration = duration1.duration
            })
            var snapImage = () => {
              var canvas = document.createElement('canvas')
              canvas.width = video.videoWidth
              canvas.height = video.videoHeight
              canvas
                .getContext('2d')
                .drawImage(video, 0, 0, canvas.width, canvas.height)
              this.duration = video.duration
              var image = canvas.toDataURL()

              var byteString = atob(image.split(',')[1])
              // separate out the mime component
              var mimeString = image.split(',')[0].split(':')[1].split(';')[0]
              // write the bytes of the string to an ArrayBuffer
              var ab = new ArrayBuffer(byteString.length)
              var dw = new DataView(ab)
              for (var j = 0; j < byteString.length; j++) {
                dw.setUint8(j, byteString.charCodeAt(j))
              }
              // write the ArrayBuffer to a blob
              const blob1 = new Blob([ab], { type: mimeString })
              const file2 = new File([blob1], 'thumbnail.png', {
                type: 'image/png',
                lastModified: new Date()
              })
              this.tempDropVideoThumbnail.push(file2)

              var success = image.length > 100000
              if (success) {
                URL.revokeObjectURL(url)
              }
              return {
                duration: video.duration
              }
            }
            video.preload = 'metadata'
            video.src = url
            video.muted = true
            video.playsInline = true
            video.play()
          }
          fileReader.readAsArrayBuffer(file)
        }
      }
    },
    thumbnailFileChanged: async function () {
      let allowedFiles = this.allowedThumbnailFiles
      let r = this.dropVideoThumbnail.filter((a, i) => {
        return allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropVideoThumbnail = r
    },
    editFolderData: async function () {
      try {
        let query = {
          description: this.folderData.description,
          isActive: this.folderData.isActive
        }
        await http.post(
          `${constants.API_URL}/api/recorded-classes/rename/${this.folderData.id}`,
          query
        )
        this.okMsg('Folder description updated successfully!')
        this.editModalOk = false
        this.getFolder(this.folderId, 'fromWatch')
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    editFolder: async function (id) {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/recorded-classes/folder/get/description/${id}`
        )
        // this.folderData = data
        if (data) {
          this.folderData.id = data.id
          this.folderData.folderName.name = data.folderName.name
          this.folderData.description = data.description
          this.folderData.isActive = data.isActive
        }
        this.editModalOk = true
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    closeEdit: async function () {
      this.editModalOk = false
    },
    activeDeactiveFolder: async function (id) {
      this.$dialog.warning({
        title: 'Update Status',
        text: 'Do you want to update status?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(
                  `${constants.API_URL}/api/recorded-classes/folder/active-inactive/${id}`
                )
                this.okMsg('Status updated successfully!')
                this.getFolder(this.folderId, 'fromWatch')
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    deleteFolder: async function (id) {
      this.$dialog.error({
        title: 'Delete Folder ?',
        text: 'Do you want to delete this folder?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.delete(
                  `${constants.API_URL}/api/recorded-classes/delete/folder/${id}`
                )
                this.okMsg('File deleted successfully!')
                this.getFolder(this.folderId, 'fromWatch')
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    deleteFile: async function (id) {
      this.$dialog.error({
        title: 'Delete File ?',
        text: 'Do you want to delete this file?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.delete(
                  `${constants.API_URL}/api/recorded-classes/delete/file/${id}`
                )
                this.okMsg('File deleted successfully!')
                this.getFolder(this.folderId, 'fromWatch')
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    activeInactiveFile: async function (id) {
      this.$dialog.warning({
        title: 'Update Status',
        text: 'Do you want to update status?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(
                  `${constants.API_URL}/api/recorded-classes/document/active-inactive/${id}`
                )
                this.okMsg('File updated successfully!')
                this.getFolder(this.folderId, 'fromWatch')
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    fileOpen: async function (path) {
      try {
        this.isLoading = true
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    uploadNow: async function () {
      let formData = new FormData()
      let url

      if (this.lessionUpload) {
        url = `${constants.API_URL}/api/recorded-classes/upload/lesson-guide/${this.folderId}`
      } else {
        formData.append('sessionName', this.sessionName)
        formData.append('description', this.ssnDesc)
        url = `${constants.API_URL}/api/recorded-classes/upload/session-docs/${this.folderId}`
        if (this.selectedSessionID) {
          formData.append('sessionID', this.selectedSessionID)
        }
        if (this.dropVideoThumbnail.length) {
          for (let i = 0; i < this.dropVideoThumbnail.length; i++) {
            formData.append('thumbnails', this.dropVideoThumbnail[i])
          }
        } else if (this.tempDropVideoThumbnail.length) {
          for (let i = 0; i < this.tempDropVideoThumbnail.length; i++) {
            formData.append('thumbnails', this.tempDropVideoThumbnail[i])
          }
        }
      }
      if (this.duration) {
        formData.append('duration', this.duration)
      }
      if (!this.dropFile.length && this.dropVideoThumbnail.length) {
        this.errMsg(`Please select Video file to upload thumbnail.`)
      } else {
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append(
            this.lessionUpload ? 'file' : 'files',
            this.dropFile[i]
          )
        }
        for (let i = 0; i < this.dropFileFlash.length; i++) {
          formData.append(
            this.lessionUpload ? 'file' : 'files',
            this.dropFileFlash[i]
          )
        }
        try {
          this.isLoading = true
          await http.post(url, formData)
          await this.getFolder(this.folderId, 'fromWatch', this.folderId)
          this.addModalOk = false
          this.uploadInputsClear()
          this.okMsg('Uploaded Successfully!')
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(`Error While uploading document: ${errorMessage}`)
        } finally {
          this.isLoading = false
        }
      }
    },
    updateVideo: async function () {
      let formData = new FormData()
      let totalDuration = 0
      totalDuration = this.videoDurationMinutes
        ? Number(this.videoDurationMinutes) * 60
        : 0
      totalDuration += this.videoDurationSeconds
        ? Number(this.videoDurationSeconds)
        : 0
      let url = `${constants.API_URL}/api/recorded-classes/update/thumbnail/${this.selectedVideoID}`

      if (this.dropVideoThumbnail.length) {
        for (let i = 0; i < this.dropVideoThumbnail.length; i++) {
          formData.append('thumbnail', this.dropVideoThumbnail[i])
        }
      }
      if (this.videoDurationMinutes || this.videoDurationSeconds) {
        formData.append('videoDuration', totalDuration)
      }
      try {
        this.isLoading = true
        await http.put(url, formData)
        await this.getFolder(this.folderId, 'fromWatch', this.folderId)
        this.editDataOk = false
        this.uploadInputsClear()
        this.okMsg('Updated Successfully!')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    addFolder: async function () {
      let formData = {}
      formData.academicYearID = this.academicYearID
      if (this.isMain) {
        formData.position = 1
        if (!this.selectedClassID) {
          this.errMsg('Kindly select class!')
          return false
        }
        formData.classID = this.selectedClassID
      }
      if (this.listType === 'WEEK') {
        formData.name = this.selectedWeek
        formData.description = this.description
        let folderPosition = this.selectedWeek.split(' ')
        this.position = folderPosition.length > 1 ? folderPosition[1] : 0
        formData.position = this.position
        formData.classID = this.selectedClassID
        formData.isActive = this.isActive
      }
      if (this.listType === 'DAY') {
        formData.name = `${this.selectedDay}` // ${this.dayNameInput ? '-' : ''} ${this.dayNameInput}
        formData.description = this.description
        let folderPosition = this.selectedDay.split(' ')
        this.position = folderPosition.length > 1 ? folderPosition[1] : 0
        formData.position = this.position
        formData.folderMapID = this.parentFolderId
        formData.isActive = this.isActive
      }

      try {
        this.isLoading = true
        let res = await http.post(
          `${constants.API_URL}/api/recorded-classes/create`,
          formData
        )
        if (res.data === 'Folder Already Exist.') {
          this.errMsg(res.data)
        } else {
          this.okMsg(res.data.message)
        }
        this.clearInputs()
        this.addModalOk = false
        this.getFolder(
          this.parentFolderId ? this.parentFolderId : null,
          'fromWatch',
          this.selectedClassID
        )
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFolder: async function (
      parentId,
      fromWatch,
      uploadWalaId,
      classID,
      folder
    ) {
      if (uploadWalaId) {
        this.idForUpload = uploadWalaId
      }
      let url = ''
      let academicYrID = this.academicYearID
      if (parentId) {
        // get subfolders
        this.selectedClassID = classID
        url = `${constants.API_URL}/api/recorded-classes/get?folderMapID=${parentId}&academicYearID=${academicYrID}`
        this.isWeek = true
        if (!fromWatch) {
          let paramz = {
            folderId: parentId,
            classID: this.selectedClassID,
            folder: folder
          }
          if (this.listType === 'WEEK') {
            paramz.weekNo = folder.position
          }
          if (this.listType === 'DAY') {
            paramz.weekNo = this.weekNo
            paramz.dayNo = folder.position
          }
          this.$router.push({ name: 'recordedSubFolder', params: paramz })
        }
      } else {
        // get main folder
        url = `${constants.API_URL}/api/recorded-classes/get?academicYearID=${academicYrID}`
      }

      if (url) {
        try {
          this.isLoading = true
          const { data } = await http.get(url)
          this.foldersArr = data.folders
          if (data.academicYearID) {
            this.academicYearID = data.academicYearID
          }
          this.filesData = []
          this.lessionGuide = data.lessonGuide
          _.each(data.files, (session) => {
            let object = {}
            object.sessionName = session.name
            object.sessionId = session.id
            object.description = session.description
            object.files = session.recordedClassesDocuments.filter((obj) =>
              _.isEqual(obj.documentType, 'LESSON')
            )
            this.filesData.push(object)
          })
          this.isMain = !parentId
          if (this.classID) {
            this.selectedClassID = parseInt(this.classID)
          }
          this.selectedClassObj = _.filter(this.classes, (a) =>
            a.id === this.selectedClassID ? a.name : ''
          )

          this.parentFolderId = parentId
          if (this.foldersArr.length > 0) {
            this.listType = this.foldersArr[0]
              ? this.foldersArr[0].nameType
              : ''
          }
          this.isInputfiledEnabled = this.listType === 'FILE'

          let folderArr1 = this.foldersArr
          if (!_.isEmpty(folderArr1)) {
            folderArr1.filter(function (e) {
              let classObj = []
              if (e.studentClassGroups) {
                e.studentClassGroups.filter(function (k) {
                  if (k.studentClassGroupsMaps && k.studentClassGroupsMaps) {
                    const objectArray = Object.entries(k.studentClassGroupsMaps)
                    objectArray.forEach(([key, value]) => {
                      if (value.studentClasses) {
                        let classArr = value.studentClasses
                        classArr.filter(function (l) {
                          classObj.push(l.name)
                        })
                      }
                    })
                    e.classes = classObj
                  }
                })
              }
              return e
            })
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
          this.isLoading = false
        }
      }
    },
    modalOpen (mode, type) {
      this.addModalOk = true
      this.isUpload = mode === 'upload'
      this.lessionUpload = type === 'lession' && mode === 'upload'
    },
    updateModal (id, name, type, description) {
      this.addModalOk = true
      this.isUpload = true
      this.lessionUpload = type === 'lession'
      this.selectedSessionID = id
      this.sessionName = name
      this.ssnDesc = description
    },
    editModal (item, name) {
      this.editDataOk = true
      this.selectedVideoID = item.id
      this.sessionName = name
      this.fileName = item.fileName
      this.videoDurationMinutes = Math.floor(Number(item.videoDuration) / 60)
      this.videoDurationSeconds = Math.floor(Number(item.videoDuration) % 60)
      this.thumbnailurl = item.thumbnailUrl
      this.thumbnailName = item.thumbnailUrl.split('/')
      this.thumbnailName = this.thumbnailName[this.thumbnailName.length - 1]
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.recordedClasses &&
            e.isActive === true
          )
        })
        this.classes = data
        // this.classes = _.filter(this.classes, (a) => a.category === 'Homeschooling Recorded Classes Global' || a.category === 'Homeschooling Recorded Classes Local')
        if (!_.isEmpty(data)) {
          data = _.filter(data, (e) => {
            return (
              e.type === constants.ClassGroupTypes.recordedClasses &&
              e.isActive === true
            )
          })
          this.classes = data
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    clearInputs () {
      if (this.isMain) {
        this.selectedClassID = ''
      }
      if (this.listType === 'WEEK') {
        this.selectedWeek = ''
      }
      if (this.listType === 'DAY') {
        this.selectedDay = ''
        // this.dayNameInput = ''
      }
      this.selectedSessionID = ''
      this.sessionName = ''
      this.folderName = ''
      this.description = ''
      this.isActive = true
    },
    uploadInputsClear () {
      this.dropFile = []
      this.selectedVideoID = ''
      this.dropVideoThumbnail = []
      this.dropFileFlash = []
      this.duration = null
      this.tempDropVideoThumbnail = []
      this.sessionName = ''
      this.selectedSessionID = ''
      this.ssnDesc = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.tile.is-child {
  border: 1px solid #ff000059;
}
.fol-name {
  overflow-wrap: break-word;
}
.foldr {
  cursor: pointer;
}
.islink {
  cursor: pointer;
}
.isBlueLink {
  color: #0d6efd;
  text-decoration: underline;
}
/* .shortFoldername {
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
.shortFoldername {
  width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shortFoldername:hover {
  overflow: visible;
  white-space: normal;
  width: auto;
  position: absolute;
  background-color: #fff;
}
</style>
